/**
 * The password floor, one number for every screen that sets one (contract v10.15; 12
 * before). The API refuses anything shorter with a 422, so this only says it earlier.
 */
export const MIN_PASSWORD = 10;

/** The hint under a field where a person chooses their own password. */
export const PASSWORD_HINT = `Mínimo ${MIN_PASSWORD} caracteres. Una frase que recuerdes vale más que una palabra con números.`;
